import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { TableTypesForm } from "@/forms/table-types-form";
import { TicketTableTypeUsage } from "../ticket-table-type-usage";

export function OrganizationSettingsTickets() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<TicketTableTypeUsage
					table="ticketTypes"
					title={t("projects.tickets")}
				/>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<ContentCard
					icon={icon("Ticket")}
					title={t("projects.ticket_types")}
				>
					<TableTypesForm
						tableTypesTable="ticketTypes"
						withIconSelect
					/>
				</ContentCard>
			</Panels.Panel>
		</Panels>
	);
}
